import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import corporateHttpService from "../../Services/corporateHttpService";
import "./CorporateBookingBadge.css";

const CorporateBookingBadge = () => {
  const [corporateInfo, setCorporateInfo] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Check if this is a corporate booking session
    const checkCorporateSession = () => {
      const token = localStorage.getItem("corporateToken");
      if (token && corporateHttpService.isCorporateBooking()) {
        try {
          setCorporateInfo(true);
        } catch (error) {
          console.error("Error decoding corporate token:", error);
        }
      }
    };

    checkCorporateSession();

    // Listen for storage changes (in case token is added/removed in another tab)
    window.addEventListener("storage", checkCorporateSession);

    return () => {
      window.removeEventListener("storage", checkCorporateSession);
    };
  }, []);

  const handleLogout = () => {
    // Clear corporate session
    corporateHttpService.clearCorporateSession();
    setCorporateInfo(null);

    // Redirect to home or hotel page
    window.location.reload();
  };

  // Don't show badge on the login page
  if (!corporateInfo || location.pathname === "/corporate-booking") {
    return null;
  }

  return (
    <div className="corporate-booking-badge">
      <div className="badge-content">
        <div className="badge-icon">
          <i className="fas fa-user-tie"></i>
        </div>
        <span className="badge-text">You are booking as agent</span>
        <button className="btn-exit" onClick={handleLogout} title="Logout">
          <i className="fas fa-sign-out-alt"></i>
          <span style={{ marginLeft: "6px" }}>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default CorporateBookingBadge;
